export function commandEndpoint(supabaseUrl: string, name: string) {
  const local = ['127.0.0.1', 'localhost', '[::1]'].includes(new URL(supabaseUrl).hostname);
  if (!local && (name === 'public-booking' || name === 'stripe-payment')) return `/api/${name}`;
  return `${supabaseUrl}/functions/v1/${name}`;
}
